import TemplateView from './TemplateView'

export default class BalanceHistoryPanelContent extends TemplateView {

    constructor({
        exportBalanceHistoryUrl,
    }) {
        super()

        this.params = {
            exportBalanceHistoryUrl,
        }
    }


    templateHtml() {
        return "<div id='userBalanceHistoryDiv'>" +
               "    <div class='userBalanceHistoryTitleDiv'>" +
               "        <div class='userBalanceHistoryTitle'><%=panelTitle%></div>" +
               "        <div class='closeButton'></div>" +
               "    </div>" +
               "    <div>" +
               "        <div>" +
               "            <table id='balanceHistoryTableThead'  class='balanceHistoryTableThead dataTable'>" +
               "                <thead>" +
               "                <tr>" +
               "                    <th class='effectiveDateCell'><%=effectiveDateTitle%></th>" +
               "                    <th class='descriptionCell'><%=descriptionTitle%></th>" +
               "                    <th class='valueCell'><%=valueTitle%></th>" +
               "                    <th class='endingBalanceCell'><%=endingBalanceTitle%></th>" +
               "                </tr>" +
               "                </thead>" +
               "            </table>" +
               "        </div>" +
               "        <div id='balanceHistoryTableBodyDiv' class='balanceHistoryTableBodyDiv'></div>" +
               "    </div>" +
               "    <div id='exportToPDFLinkDiv'>" +
               "        <form id='BalanceHistoryForm' class='balanceHistoryForm' method='post' action='<%=actionUrl%>'>" +
               "            <input type='hidden' name='userId' value=''/>" +
               "            <input type='hidden' name='balanceType' value=''/>" +
               "            <div class='exportImg'></div>" +
               "            <span class='exportToPDFLinkTitle'><%=exportText%></span>" +
               "        </form>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            panelTitle: 'common.balance_history.balance_history_panel.title',
            effectiveDateTitle: 'common.balance_history.table.date_cell.title',
            descriptionTitle: 'common.balance_history.table.description_cell.title',
            valueTitle: 'common.balance_history.table.value_cell.title',
            endingBalanceTitle: 'common.balance_history.table.balance_cell.title',
            exportText: 'common.pto_history.export_link.text',
        }
    }

    templateModel() {
        return {
            actionUrl : this.params.exportBalanceHistoryUrl,
        }
    }

    afterRender() {
        this.balanceHistoryPanelActions = new BalanceHistoryPanel().init(this.$el)

        this.find('#exportToPDFLinkDiv').on('click', () => {
            this.find('.balanceHistoryForm').submit()
        })
    }

    updateTitle(message) {
        this.balanceHistoryPanelActions.updateTitle(message)
    }

    setOnCloseCallback(callback) {
        this.balanceHistoryPanelActions.setOnCloseCallback(callback)
    }

    updateLinkState(recordsLength, userId, balanceType) {
        this.balanceHistoryPanelActions.updateLinkState(recordsLength, userId, balanceType)
    }

    showAt(element, params) {
        this.balanceHistoryPanelActions.showAt(element, params)
    }
}



// WEBPACK FOOTER //
// ./web/js/BalanceHistoryPanelContent.js